module.exports = __webpack_public_path__ + "img/daki.cba4e39e.png";